/*
 * Note lane header (W2-03): two dense rows inside the timeline host's 52 px header slot. Tokens only. A size
 * container (W3-05, UX-041): in a narrow lane the "Also" caption gives way to the controls.
 */

.header {
  container-type: inline-size;
  container-name: lane-header;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  height: 100%;
  padding: 2px var(--space-1);
  overflow: hidden;
  background: var(--color-surface-1);
  border-bottom: var(--border-width) solid var(--color-divider);
  color: var(--color-text);
  font-size: var(--text-xs);
}

.row {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  min-width: 0;
  height: 22px;
}

.group {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  min-width: 0;
}

.spacer {
  flex: 1 1 auto;
}

.grow {
  flex: 1 1 auto;
  min-width: 72px;
}

/* The sides filter: three icon toggles side by side. */
.segmented {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 1px;
  padding: 1px;
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-sm);
}

@container lane-header (max-width: 239px) {
  .caption {
    display: none;
  }
}

.compact {
  display: inline-flex;
  min-width: 0;
}

.compact button[role='combobox'] {
  height: 22px;
  padding: 0 var(--space-1) 0 var(--space-2);
  font-size: var(--text-xs);
}

.compact > div {
  width: 100%;
  min-width: 0;
}

.caption {
  color: var(--color-text-subtle);
  white-space: nowrap;
}

.lineName {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  font-weight: var(--weight-semibold);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: var(--radius-pill);
  background: var(--color-surface-3);
  color: var(--color-text);
  transform-origin: 50% 50%;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  max-width: 120px;
  height: 18px;
  padding: 0 2px 0 var(--space-2);
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-pill);
  background: var(--color-surface-2);
}

.chipText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chipRemove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  padding: 0;
  border: none;
  border-radius: var(--radius-pill);
  background: transparent;
  color: var(--color-text-muted);
}

.chipRemove:hover {
  background: var(--color-surface-hover);
  color: var(--color-text);
}

.chipRemove:focus-visible {
  outline: var(--focus-ring-width) solid var(--color-focus-ring);
  outline-offset: var(--focus-ring-offset);
}
